import {
  store,
  deleteAllOrderItems,
  resetNotViewedOrders,
  deleteOrderForEditDetails,
  clearFoods,
  clearCombos,
  clearCategories,
  updateUserAccountInfo,
  clearFoodCategoriesGroups
} from "@redux"

const clearSiteData = async () => {
  store.dispatch(updateUserAccountInfo({ branchId: "" }))
  store.dispatch(deleteAllOrderItems())
  store.dispatch(resetNotViewedOrders())
  store.dispatch(deleteOrderForEditDetails())
  store.dispatch(clearFoods())
  store.dispatch(clearCombos())
  store.dispatch(clearCategories())
  store.dispatch(clearFoodCategoriesGroups())
}

export default clearSiteData